import { Component } from '@angular/core';
import { DataService } from '../../../services/data/data.service';
import { Perspectivas, Areas, Unidad_Medida, Meses, procesamiento, alertas, obtenerError, Metas, Indicadores, Adicionales } from '../../../models/Formulacion/indicadores-metas/datos';
import { CookieService } from 'ngx-cookie-service';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { messages } from '../../funciones/mensajes';
import { TranslateService } from '@ngx-translate/core';
import { FuncionesRiesgo } from '../../funciones/funcionesGenerales';
import { ExcelService } from '../../../services/excel/excel.service';
import { PlanificacionService } from '../../../services/gestion/planificacion/planificacion.service';
import { ResponsableService } from '../../../services/gestion/responsable/responsable.service';
import { ObjetivoService } from '../../../services/gestion/objetivo/objetivo.service';
import { IndicadorService } from '../../../services/gestion/indicadores/indicador.service';
import { AdicionalService } from '../../../services/gestion/adicional/adicional.service';
import { MetaService } from '../../../services/gestion/meta/meta.service';
import { comment } from '../../../services/formulacion/proyectos-estrategicos/proyectosestrategicos.service';
import { PERMISOS } from '../../../shared/catalogos';
import { FiltersM } from '../../../components/models';

@Component({
  selector: 'app-indicadores-metas',
  templateUrl: './indicadores-metas.component.html',
  styleUrl: './indicadores-metas.component.css'
})
export class IndicadoresMetasComponent {
  public readonly permisos = PERMISOS;
  Filters = FiltersM;

  public aniosDisponibles = [];
  public idPlanificacion :any;

  minDate: any;
  maxDate: any;

  public periodicidad: any = [];
  public data: any = [];
  public perspectivas: Perspectivas[] = [];
  public objetivos: any[] = [];
  public areas: Areas[] = [];
  public unidades_med: Unidad_Medida[] = [];
  public meses = [{name: 'ene'}, {name: 'feb'}, {name: 'mar'}, {name: 'abr'}, {name: 'may'}, {name: 'jun'}, {name: 'jul'}, {name: 'ago'}, {name: 'sep'}, {name: 'oct'}, {name: 'nov'}, {name: 'dic'}];
  public idPers: number = 0;
  public indic: any;
  public indicadoresAll: any[] = [];
  public indicadores: any[] = [];

  public metas: any[] = [];
  public selectAll = true;
  public posMet = [];
  public verCodigo = false;
  public tenden = [{id: '1', name: 'Ascendente'},{id: '-1', name: 'Descendente'}];
  public titModal = '';
  public accionModal = '';
  public fechaAct;
  public diccionarioAdicionales: any = [];

  modal = false;
  modal2 = false;
  modal3 = false;
  public viewTablero = false;
  public skeleton = ['','',''];

  /** Grupo de validación de datos */
  formIndicador = new FormGroup({ 
    inputCodigo: new FormControl(''),
    inputNameInd: new FormControl('', [Validators.required]),
    inputDescription: new FormControl(''),
    inputCalculation: new FormControl('', [Validators.required]),
    inputObjective: new FormControl('default', [Validators.required]),
    inputFechaIn: new FormControl('', [Validators.required]),
    inputFechaFn: new FormControl('', [Validators.required]),
    inputParam: new FormControl(''),
    inputBaseLine: new FormControl(''),
    inputGlobalGoal: new FormControl('', [Validators.required]),
    inputPeriodicidad: new FormControl('default', [Validators.required]),
    inputUnidadMed: new FormControl('default', [Validators.required]),
    inputTendencia: new FormControl('default', [Validators.required]),
    inputArea: new FormControl('default', [Validators.required]),
  });
  formAdicional = new FormGroup({
    inputName: new FormControl('', [Validators.required]),
    inputType: new FormControl('',[Validators.required])
  })

  private set = {
    inputCodigo: '',
    inputNameInd: '',
    inputDescription: '',
    inputCalculation: '',
    inputObjective: 'default',
    inputFechaIn: '',
    inputFechaFn: '',
    inputParam: '',
    inputBaseLine: '',
    inputGlobalGoal: '',
    inputPeriodicidad: 'default',
    inputUnidadMed: 'default',
    inputTendencia: 'default',
    inputArea: 'default'
  }

  myFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    return day !== 0 && day !== 6;
  };

  ngOnInit(){
    this.fechaAct = moment().format("YYYY-MM-DD");
  }

  constructor(
    public dataService: DataService,
    private excelService: ExcelService,

    private cookies: CookieService,
    private translate: TranslateService,

    private planificacionService: PlanificacionService,
    private responsableService: ResponsableService,
    private objetivosService: ObjetivoService,
    private indicadorService: IndicadorService,
    private adicionalService: AdicionalService,
    private metaService: MetaService,
  ){
    moment.updateLocale('en',{
      months: [
        "Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto",
        "Septiembre","Octubre","Noviembre","Diciembre"
      ],
      monthsShort: [
        "Ene","Feb","Mar","Abr","May","Jun","Jul","Ago",
        "Sep","Oct","Nov","Dic"
      ]
    });
    this.obtData();
  }

  //Obtencion de periodos disponibles 
  public async obtData(){
    this.idPlanificacion = Number(this.cookies.get('idInstitucion'));
    const plan = await this.planificacionService.getPlanificacionByIdGQL(this.idPlanificacion);

    const fechaini = moment(plan.initial_date.split('T')[0]);
    const fechafin = moment(plan.end_date.split('T')[0]);
    this.minDate = fechaini.format('YYYY-MM-DD');
    this.maxDate = fechafin.format('YYYY-MM-DD');
    const filters = {
      'Lunes-Viernes': (d: Date | null): boolean => {
        const day = (d || new Date()).getDay();
        return day !== 0 && day !== 6;
      },
      'Lunes-Sabado': (d: Date | null): boolean => {
        const day = (d || new Date()).getDay();
        return day !== 0;
      },
      'Lunes-Domingo': (): boolean => true,
    };
    
    this.myFilter = filters[plan.business_days] || (() => true);
    this.aniosDisponibles = [];
    while( fechaini.isSameOrBefore(fechafin, 'year') ){
      const fech = moment();
      var check = false;
      if(fechaini.isSame(fech, 'year')){
        check = true;
      }
      this.aniosDisponibles.push({
        name: fechaini.format('YYYY'),
        check: check,
      });
      fechaini.add(1, "years");
    }
    const selec = this.aniosDisponibles.find(e => e.check);
    if(!selec) this.aniosDisponibles[this.aniosDisponibles.length-1].check = true;
    const res1 = await firstValueFrom(this.responsableService.getResponsable());
    this.areas = [];
    for(const are of res1){
      if(plan.institution.id === are.institution.id){
        this.areas.push({
          id: are.id,
          nombre: are.name,
        });
      }
    }
    this.areas = this.ordenamientoPer(this.areas);

    const res3 = await firstValueFrom(this.indicadorService.getUnides());
    this.unidades_med = [];
    for(const uni of res3){
      this.unidades_med.push({
        nombre: uni.name,
        id: uni.id,
      });
    }
    this.unidades_med = this.ordenamientoPer(this.unidades_med);

    await this.perPers(plan);
    this.perspectivas =  this.ordenamientoPer(this.perspectivas);
    this.objetivos = this.ordenamientoPer(this.objetivos);

    await this.getIndicators();
    this.viewTablero = true;
  }
  private async getIndicators(){
    var indicators = [];
    for(const obj of this.objetivos){
      const res = await this.indicadorService.getIndicadoresByObjetiveGQL(Number(obj.id));
      indicators = indicators.concat(res);
    }
    this.indPers(indicators);
  }
  
  private ordenamientoPer(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.id) > Number(b.id)) {
        return 1;
      }
      if (Number(a.id) < Number(b.id)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }

  /** Tratado y filtrado de los datos */
  public async perPers(plan: any){
    var aux = [], aux2 = [];
    for(const per of plan.perspectives){  
      aux.push({
        nombre: per.name,
        name: per.name,
        descripcion: per.descripcion,
        planningId: plan.id,
        id: per.id,
        check: true,
      });
    }
    var objetivos = [];
    for(const per of aux){
      const res = await this.objetivosService.getObjectivesByPerspectiveGQL(Number(per.id))
      objetivos = objetivos.concat(res);
    }
    for(const obj of objetivos){
      aux2.push({
        nombre: obj.name,
        descripcion: obj.description, 
        ponderacion: obj.weighing,
        perspectiveId: obj.perspective.id,
        perspectiva: aux.find(p => p.id === obj.perspective.id), 
        id: obj.id
      })
    }
    this.perspectivas = [];
    this.objetivos = [];
    this.perspectivas = aux;
    this.objetivos = aux2;
  }
  public indPers(array: any){
    var aux = [], aux2 = [];
    array.forEach( ind => {
      var metas = ind.goals.map(m => {
        return {
          id: m.id,
          nombre: moment(m.period),
          descripcion: m.value,
          real: m.real,
        }
      });
      aux2 = aux2.concat(ind.goals.map(m => {
        return {
          id: m.id,
          nombre: moment(m.period),
          descripcion: m.value,
          real: m.real,
          indicatorId: ind.id
        }
      }));
      aux.push({
        id: ind.id,
        nombre: ind.name,
        descripcion: ind.description,
        calculo: ind.calculation,
        ponderacion: ind.weighing,
        objetiveId: ind.objectiveId,
        objective: ind.objective,
        linea_base: ind.baseline,
        fecha_inicio: moment(ind.initialDate.split('T')[0]),
        fecha_fin: moment(ind.endDate.split('T')[0]),
        periodicidad: ind.periodicity.toLowerCase(),
        meta_global: ind.globalGoal,
        measureId: ind.measure.id,
        areaId: ind.area.id,
        area: ind.area,
        tendencia: ind.tendency,
        parametro: ind.paramType,
        adicionales: this.ordenamientoAdi([].concat(ind.additions)),
        perspective: this.perspectiva(ind.objectiveId),
        metas: metas,
      });
    });

    this.indicadoresAll = [];
    this.metas = [];

    this.indicadoresAll = aux;
    this.metas = aux2;

    this.indicadoresAll = this.ordenamientoPer(this.indicadoresAll);
    this.indicadoresAll = this.ordenamientoInd(this.indicadoresAll);
    this.diccionarioAdicionales = this.indicadoresAll[0]?.adicionales ?? [];


    // this.eliminacionMetasDup();
    
    this.metas = this.ordenamientoPer(this.metas);
    
    this.obtDataMostrar();
  }

  private ordenamientoInd(array: any){
    array.sort(function (a: any, b: any) {
      if (Number(a.objetiveId) > Number(b.objetiveId)) {
        return 1;
      }
      if (Number(a.objetiveId) < Number(b.objetiveId)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }
  private ordenamientoAdi(array: any){
    array.sort(function (a: any, b: any) {
      if ((a.name) > (b.name)) {
        return 1;
      }
      if ((a.name) < (b.name)) {
        return -1;
      }
      // a must be equal to b
      return 0;
    });
    return array;
  }

  private perspectiva(objetiveId){
    for(const obj of this.objetivos){
      if(Number(obj.id) === Number(objetiveId)){
        return obj.perspectiva.nombre;
      }
    }
  }

  /** Datos a mostrar */
  private obtDataMostrar(){
    this.indicadores = [];
    for(const ind of this.indicadoresAll){
      if(this.perteneceAlAnio(ind)){
        this.indicadores.push(ind);
      }
    }
  }

  /* Validar el año */
  private perteneceAlAnio(ind: any){
    var anioIn = ind.fecha_inicio.format('YYYY'), anioFn = ind.fecha_fin.format('YYYY');
    var anioAc = Number(this.aniosDisponibles.filter(an => an.check)[0].name);
    if(Meses.compararAnio(anioIn, anioFn, anioAc)){
      return true;
    }
    return false;
  }

  public yearChange(anio: any) {
    this.aniosDisponibles.forEach(an => { an.name === anio.name? an.check=true:an.check=false });
    this.obtDataMostrar();
  }
  public cambioPer(per: any){
    if(per === 'consolidado'){
      this.seleccionarTodo();
      return;
    }
    for(const pers of this.perspectivas){
      if(per.id === pers.id){
        pers.check = !pers.check;
      }
    }
  }
  public seleccionarTodo(){
    for(const pers of this.perspectivas){
      if(this.selectAll){pers.check = false;}
      else {pers.check = true;}
    }
    this.selectAll = !this.selectAll;
  }
  public mostrarPer(per: any){
    if(this.selectAll){
      return true;
    }
    var numSelec = 0;
    for(const per of this.perspectivas){
      if(per.check){
        numSelec ++;
      }
    }
    if(numSelec === 0){
      return true;
    }
    return per.check;
  }
  public openModalInd(modal, per?: any, ind?: any ){
    switch(modal){
      case 'indicador':
        this.idPers = per.id;
        //TODO: Pruebas solo descomentar para hacer pruebas
        // this.formIndicador.controls['inputNameInd'].setValue('Indicador Prueba');
        // this.formIndicador.controls['inputDescription'].setValue('Descripción de prueba');
        // this.formIndicador.controls['inputCalculation'].setValue('Cálculo de prueba');
        // this.formIndicador.controls['inputBaseLine'].setValue('10');
        // this.formIndicador.controls['inputGlobalGoal'].setValue('100');
        // this.formIndicador.controls['inputPeriodicidad'].setValue('mensual');
        // this.formIndicador.controls['inputUnidadMed'].setValue('1');
        // this.formIndicador.controls['inputTendencia'].setValue('1');
        
        this.formIndicador.controls['inputFechaIn'].setValue(this.minDate);
        this.formIndicador.controls['inputFechaFn'].setValue(this.maxDate);
        this.titModal = this.translate.instant('gestion.formulacion.ind-metas.titModal1');
        this.accionModal = 'guardar'
        break;
      case 'editarInd':
        this.indic = ind;
        this.idPers = per.id;
        this.formIndicador.controls['inputNameInd'].setValue(this.indic.nombre);
        this.formIndicador.controls['inputDescription'].setValue(this.indic.descripcion);
        this.formIndicador.controls['inputCalculation'].setValue(this.indic.calculo);
        this.formIndicador.controls['inputObjective'].setValue(this.indic.objetiveId);
        this.formIndicador.controls['inputParam'].setValue(this.indic.parametro);
        this.formIndicador.controls['inputBaseLine'].setValue(this.indic.linea_base);
        this.formIndicador.controls['inputFechaIn'].setValue(moment(this.indic.fecha_inicio, 'DD/MM/YYYY').format('YYYY-MM-DD'));
        this.formIndicador.controls['inputFechaFn'].setValue(moment(this.indic.fecha_fin, 'DD/MM/YYYY').format('YYYY-MM-DD'));
        this.formIndicador.controls['inputGlobalGoal'].setValue(this.indic.meta_global);
        this.formIndicador.controls['inputPeriodicidad'].setValue(this.indic.periodicidad);
        this.formIndicador.controls['inputUnidadMed'].setValue(this.indic.measureId);
        this.formIndicador.controls['inputTendencia'].setValue(this.indic.tendencia);
        this.formIndicador.controls['inputArea'].setValue(this.indic.areaId);
        this.titModal = this.indic.nombre;
        this.accionModal = 'editar';
        break;

    }
    // document.getElementById('modalInd')!.style.display = 'block';
    this.modal = true;
  }

  public clickFuera(event, modal){
    if (event.target === document.getElementById(modal)) {
      document.getElementById(modal).classList.add('moveShake');
      setTimeout(() => {
        document.getElementById(modal).classList.remove('moveShake');
      },600);
    }
  }
    // Cerrar modales
  public closeModal(){
    this.modal = false;
    this.modal2 = false;
    this.modal3 = false;
    this.formIndicador.reset(this.set);
  }
  // Agregar adicional
  public modalAdicional(){
    this.titModal = this.translate.instant('gestion.formulacion.ind-metas.titModal3');
    this.modal3 = true;
  }
  public async guardarAdi(){
    var name = this.formAdicional.controls['inputName'].value;
    var tipo = this.formAdicional.controls['inputType'].value;
    var adidionales = [];
    const total = this.indicadoresAll.length;
    messages.messageSaving(this.translate.instant('swal.editandoInfo'), this.translate.instant('swal.espere'));
    for(const ind of this.indicadoresAll){
      var adic = new Adicionales();
      adic.nombre = name;
      adic.tipo = tipo;
      adic.indicadorId = ind.id;
      switch(tipo){
        case 'texto': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
        case 'moneda': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
        case 'numero': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
        case 'archivo': adic.nota = ''; adic.archivos = ''; adic.monto = 0; break;
      }
      adidionales.push(adic);
      try{
        const res = await firstValueFrom(this.adicionalService.postAdicionales(adic));
        ind.adicionales.push({
          ...res,
          files: [],
          comments: []
        })
      }catch(err){
        Swal.close();
        messages.errorMessageGraph(err)
      }
    }
    Swal.close();
    messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    this.diccionarioAdicionales = this.indicadoresAll[0].adicionales;
    this.closeModal();
  }
  /** Metodo de edición del adicional */
  public async editar(adi: any, id:any){
    var inputValue: any, introdujo: any, guardo = false;
    switch(adi.type){
      case 'texto': inputValue = adi.note; break;
      case 'moneda': inputValue  = adi.amount; break;
      case 'numero': inputValue  = this.obtComment(adi.comments); break;
      case 'archivo': inputValue  = adi.files; break;
    }
    switch(adi.type){
      case 'moneda':
        introdujo = await Swal.fire({
          title: 'Ingresa el valor',
          text: "",
          input: 'number',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return 'Ingeresa un dato valido';
            }
            guardo = true;
            return '';
          }
        });
      break; 
      case 'numero': 
        introdujo = await Swal.fire({
          title: 'Ingresa el valor',
          text: "",
          input: 'text',
          inputValue: inputValue,
          showCancelButton: true,
          confirmButtonColor: '#ff6b00',
          cancelButtonColor: '#B9B9BC',
          confirmButtonText: 'Aceptar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
          customClass: {
            actions: 'aleema-swal-actions',
            confirmButton: 'aleema-swal-confirm',
            cancelButton: 'aleema-swal-cancel',
            input: 'aleema-swal-select'
          },
          inputValidator: (value) => {
            if (!value) {
              return 'Ingeresa un dato valido';
            }
            guardo = true;
            return '';
          }
        });
      break;
    }
    if(guardo){
      switch(adi.type){
        case 'texto': adi.note = introdujo.value; break;
        case 'moneda':
          adi.amount = introdujo.value;
          try{
            const res = await firstValueFrom(this.adicionalService.patchAdicionales(adi,id));
            messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
          }catch(err){
            let er = obtenerError.errorObt(err['error'].message);
            messages.errorMessageGraph(er);
          }          
        break;
        case 'numero':
          adi.note = introdujo.value;
          var existe = false;
          var per =  Number(this.aniosDisponibles.filter(an => an.check)[0].name);
          for(const comen of adi.comments){
            var percom = Number(moment(comen.createdAt).format('YYYY'));
            if(per === percom){
              comen.comment = introdujo.value;
              existe = true;
              try{
                const res = await firstValueFrom(this.adicionalService.patchComment(comen, adi.id));
                messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
              }catch(err){
                let er = obtenerError.errorObt(err['error'].message);
                messages.errorMessageGraph(er);
              }
            }
          }
          if(!existe){
            var date = new Date('1'+'-1-'+Number(this.aniosDisponibles.filter(an => an.check)[0].name));
            var aux = {
              comment: introdujo.value,
              createdAt: date.toISOString(),
              id: 0,
            }
            try{
              const res = await firstValueFrom(this.adicionalService.postComment(aux, adi.id));
              aux.id = res.id;
              adi.comments.push(aux);
              messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
            }catch(err){
              let er = obtenerError.errorObt(err['error'].message);
              messages.errorMessageGraph(er);
            }
          }
        break;
        case 'archivo': adi.files = introdujo.value; break;
      }
      
    }else {
      messages.cancelMessage(this.translate.instant('swal.cancelado'));
    }
  }
  /* Edición y eliminación de adicionales */
  public async editarAdicional(adi: any){
    var guardo = false;
    var introdujo = await Swal.fire({
      title: 'Ingrese el nombre del adicional',
      text: "",
      input: 'text',
      inputValue: adi.name,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      showCancelButton: true,
      inputValidator: (value) => {
        guardo = true;
        return '';
      }
    });

    if(guardo){
      var edit = 0;
      const name = adi.name;
      messages.messageSaving(this.translate.instant('swal.editandoInfo'), this.translate.instant('swal.espere'));
      for(const ind of this.indicadoresAll){
        const adEdit = ind.adicionales.filter(ad => ad.name === name && ad.type === adi.type);
        if(adEdit.length !== 0){
          adEdit[0].name = introdujo.value;
          try{
            const res = await firstValueFrom(this.adicionalService.patchAdicionalesNombre(adEdit[0]));
          }catch(err){
            let er = obtenerError.errorObt(err['error'].message);
            messages.errorMessageGraph(er);
          }
        }
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.diccionarioAdicionales = this.indicadoresAll[0].adicionales;
    }else{
      messages.cancelMessage(this.translate.instant('swal.cancelado'));
    }
  }
  public async eliminarAdicional(adi: any){
    const guardo = await messages.confirmationSave(
      this.translate.instant('¿Esta seguro de eliminar este adicional?'),
      this.translate.instant('Esta acción borrara permanente la información contenida en el adicional.'),
      this.translate
    );

    if(guardo){
      var edit = 0;
      const name = adi.name;
      messages.messageSaving('Eliminando adicional', 'Espere un momento por favor...');
      for(const ind of this.indicadoresAll){
        const adEdit = ind.adicionales.filter(ad => ad.name === name && ad.type === adi.type);
        ind.adicionales = ind.adicionales.filter(ad => !(ad.name === name && ad.type === adi.type));
        if(adEdit.length !== 0){
          try{
            const res = await firstValueFrom(this.adicionalService.deleteAdicional(adEdit[0]));
          }catch(err){
            let er = obtenerError.errorObt(err['error'].message);
            messages.errorMessageGraph(er);
          }
        }
      }
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      this.diccionarioAdicionales = this.indicadoresAll[0].adicionales;
    }
  }

  // Escritura de los datos
  public escribiObj(obj: any,ind: any, i: any){
    if(this.indicadores.length === 1){
      return obj;
    }else{
      if(i!=0){
        if(Number(ind.objetiveId) != Number(this.indicadores[i-1].objetiveId))
          return obj;
      }else if(i === 0){
        return obj;
      }
    }
    return '';
  }
  public escrituraMet(mes: any, id: any, ind: any){
    const an = this.aniosDisponibles.find(an => an.check).name;
    const fechSel = moment(`${Meses.getMesesNum(mes)}-${an}`, 'MM-YYYY');

    const ex = ind.metas.find(c => c.nombre.isSame(fechSel, 'month') === true);

    if(ex){
      return FuncionesRiesgo.formatearnormal(Number(ex.descripcion))
    }
    return '';
  }
  /** Edición en tabla */
  public async edicionPond(Ind: any){
    var inputValue = Ind.ponderacion, introdujo: any, guardo = false;
    var nombre = 'obj.name';

    introdujo = await Swal.fire({
      title: 'Ingrese la ponderación',
      text: "",
      input: 'number',
      inputValue: inputValue,
      showCancelButton: true,
      confirmButtonColor: '#ff6b00',
      cancelButtonColor: '#B9B9BC',
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        actions: 'aleema-swal-actions',
        confirmButton: 'aleema-swal-confirm',
        cancelButton: 'aleema-swal-cancel',
        input: 'aleema-swal-select'
      },
      inputValidator: (value) => {
        if (!value) {
          return 'Ingerese un dato valido';
        }
        guardo = true;
        return '';
      }
    });

    if(guardo){
      Ind.ponderacion = Number(introdujo.value);

      try{
        const res = await firstValueFrom(this.indicadorService.patchIndicadoresPond(Ind));
        messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
      }catch(err){
        let er = obtenerError.errorObt(err['error'].message);
        messages.errorMessageGraph(er);
      }
    }
  }
  /** Eliminación de indicadores */
  public async eliminarInd(ind: any){
    try{
      messages.messageSaving(this.translate.instant('swal.eliminandoInfo'),this.translate.instant('swal.espere'))
      await firstValueFrom(this.indicadorService.deleteIndicadores(ind));
      await this.getIndicators();
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }catch(err){
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }
  // Metas
  public modalMeta(idIn: any){
    this.indic = idIn;
    var per = 0;
    this.posMet = [];
    switch(this.indic.periodicidad){
      case 'mensual': per = 1; break;
      case 'bimestral': per = 2; break;
      case 'trimestral': per = 3; break;
      case 'cuatrimestral': per = 4; break;
      case 'semestral': per = 6; break;
      case 'anual': per = 12; break;
    }
    const fecIn = moment(this.indic.fecha_inicio.format('YYYY-MM-DD'));
    const fecFin = moment(this.indic.fecha_fin.format('YYYY-MM-DD'));
    fecIn.subtract(1,'months');
    while(fecIn.isBefore(fecFin, 'month')){
      fecIn.add(per,'months');
      
      var fech;
      if(fecIn.isAfter(fecFin,"month")){
        fech = fecFin;
      }else{
        fech = fecIn;
      }
      const ex = this.metas.find(c => c.nombre.isSame(fech, 'month') === true && c.indicatorId === this.indic.id);
      if(ex){
        this.posMet.push({
          nombre: fech.format('MMM-YY'),
          descripcion: Number(ex.descripcion),
          indicatorId: ex.indicatorId,
        });
      }else{
        this.posMet.push({
          nombre: fech.format('MMM-YY'),
          descripcion: '',
          indicatorId: this.indic.id,
        });
      }
    }
    this.titModal = this.indic.nombre;
    this.posMet[this.posMet.length-1].descripcion = this.indic.meta_global;
    this.formIndicador.controls['inputNameInd'].setValue(this.indic.nombre);
    this.formIndicador.controls['inputDescription'].setValue(this.indic.ponderacion);
    this.formIndicador.controls['inputCalculation'].setValue(this.indic.calculo);
    this.formIndicador.controls['inputObjective'].setValue(this.objetivos.find(c=>this.indic.objetiveId == c.id).nombre );
    this.formIndicador.controls['inputParam'].setValue(this.indic.parametro);
    this.formIndicador.controls['inputBaseLine'].setValue(this.indic.linea_base);
    this.formIndicador.controls['inputFechaIn'].setValue(moment(this.indic.fecha_inicio, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    this.formIndicador.controls['inputFechaFn'].setValue(moment(this.indic.fecha_fin, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    this.formIndicador.controls['inputGlobalGoal'].setValue(this.indic.meta_global);
    this.formIndicador.controls['inputPeriodicidad'].setValue(this.indic.periodicidad);
    this.formIndicador.controls['inputUnidadMed'].setValue(this.indic.measureId);
    this.formIndicador.controls['inputTendencia'].setValue(this.indic.tendencia == 1? 'Ascendente':'Descendente');
    this.formIndicador.controls['inputArea'].setValue(this.indic.areaId);
    this.modal2 = true;
  }
  public async guardarMeta(){
    messages.messageSaving(this.translate.instant('swal.editandoInfo'), this.translate.instant('swal.espere'));
    for(var i = 0; i < this.posMet.length; i++){
      this.posMet[i].descripcion =  document.getElementById('meta'+i)["value"];
    }
    var aux = JSON.parse(JSON.stringify(this.posMet));
    await aux.forEach( async pmet => {
      const f = this.metas.find(m => m.nombre.format('MMM-YY') === pmet.nombre && m.indicatorId === pmet.indicatorId);
      if(f){
        if(pmet.descripcion !== ''){
          f.descripcion = pmet.descripcion;
          try{
            const res = await firstValueFrom(this.metaService.patchMetas(f)); 
          }catch(err){
            let er = obtenerError.errorObt(err['error'].message);
            messages.errorMessageGraph(er);
          }
        }else if(f.real !== null){
          Swal.close();
          messages.messageSaving(this.translate.instant('swal.editandoInfo'), this.translate.instant('swal.espere'));
          const guardo = await messages.confirmationSave(
            this.translate.instant('¿Seguro que desea eliminar la meta de '+f.nombre+'?'),
            this.translate.instant('Esta meta contiene datos cargados en seguimiento'),
            this.translate
          );
          if(guardo){
            this.metas = this.metas.filter(m => m.id !== f.id);
            try{
              const res = await firstValueFrom(this.metaService.deleteMetas(f));
            }catch(err){
              let er = obtenerError.errorObt(err['error'].message);
              messages.errorMessageGraph(er)
            }
          }
          messages.messageSaving(this.translate.instant('swal.eval'), this.translate.instant('swal.espe'))
        }else{
          this.metas = this.metas.filter(m => m.id !== f.id);
          try{
            const res = await firstValueFrom(this.metaService.deleteMetas(f));
          }catch(err){
            let er = obtenerError.errorObt(err['error'].message);
            messages.errorMessageGraph(er)
          }
        }
      }else if(pmet.descripcion !== ''){
        try{
          pmet.nombre = new Date(moment(pmet.nombre, 'MMM-YY').format('YYYY-MM-DD'));
          const re = await firstValueFrom(this.metaService.postMetas(pmet));
          const met = {
            id: re.id,
            nombre: moment(re.period.split('T')[0]),
            descripcion: Number(re.value),
            real: re.real,
            indicatorId: `${re.indicatorId}`,
          }
          const ind = this.indicadores.find( i => Number(i.id) === Number(re.indicatorId));
          ind.metas.push(met);
          this.metas.push(met);
        }catch(err){
          Swal.close();
          messages.errorMessageGraph(err)
          return;
        }
      }
    });
    const met = this.metas.filter(m => m.indicatorId === this.indic.id);
    this.indic.metas = met;
    messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    this.closeModal()    
  }
  /** Metodo de envio al guardado */
  public async alertas(aler: any, indi?: any){
    if(aler === 'editar'){
      var meta: any = this.formIndicador.controls['inputGlobalGoal'].value;
      var fecIn: any = this.formIndicador.controls['inputFechaIn'].value;
      var fecFin: any = this.formIndicador.controls['inputFechaFn'].value;

      var per = this.formIndicador.controls['inputPeriodicidad'].value;
      var text = '', i=0;      
      this.metas.forEach(met => { if(met.indicatorId === this.indic.id){i++;} })
      if((per != this.indic.periodicidad || (fecIn - this.indic.fecha_inicio) !== 0 || (fecFin - this.indic.fecha_fin) !== 0) && i != 0 ){
        text = 'Se borrarán las metas creadas';
      }

      if(text != ''){
        var aux: Metas[] = [];
        for(const met of this.metas){              
          if(met.indicatorId === this.indic.id){
            this.eliminarMeta(met)
          }
        }
        this.metas = this.metas.filter(m => m.indicatorId !== this.indic.id);
        this.indic.metas = [];
      }
      if(meta !== this.indic.meta_global && this.indic.metas.length !== 0){
        this.indic.metas.sort(function (a: any, b: any) {
          if(a.nombre !== undefined && b.nombre !== undefined){
            if (a.nombre.getTime() > b.nombre.getTime()) {
              return 1;
            }
            if (a.nombre.getTime() < b.nombre.getTime()) {
              return -1;
            }
          }
          return 0;
        });
        this.indic.metas[this.indic.metas.length-1].descripcion = meta;
        this.patchMeta();
      }
      this.guardarIndEdit();
    }else if(aler === 'guardar'){
      this.guardarInd();
    }else if(aler === 'eliminar'){
      var text = '', i=0;
      this.metas.forEach(met => { if(met.indicatorId === indi.id){i++;} })
      if(i != 0 ){
        text = 'Se borrarán las metas creadas';
      }
      const result = await messages.confirmationSave(
        this.translate.instant('¿Seguro que deseas eliminar el indicador?'),
        this.translate.instant(`<strong>${indi.nombre}</strong> <br> ${text}`),
        this.translate
      );
      if (result) {
        for(const met of this.metas){
          if(met.indicatorId === indi.id){
            this.eliminarMeta(met)
          }
        }
        this.eliminarInd(indi);
      } 
    }
  }
  private async eliminarMeta(meta){
    try{
      const res = await firstValueFrom(this.metaService.deleteMetas(meta));
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }catch(err){
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }
  private async patchMeta(){
    try{
      const res = await firstValueFrom(this.metaService.patchMetas(this.indic.metas[this.indic.metas.length-1]));
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }catch(err){
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
  }
  // Obtener comentarios
  private obtComment(com : any){
    for(const comen of com){
      var per =  Number(this.aniosDisponibles.filter(an => an.check)[0].name);
      var percom = Number(moment(comen.createdAt).format('YYYY'));
      if(per === percom){
        return comen.comment;
      } 
    }
    return '';
  }
  //  Impresión de los adicionales 
  public imprimir(ad: any){
    switch(ad.type){
      case 'texto': return ad.note;
      case 'moneda': return FuncionesRiesgo.formatearnormal(ad.amount);
      case 'numero': return this.obtComment(ad.comments);//this.obtComment(ad.comments);
      case 'archivo': return '';
    }
  } 
  // Edición de indicador
  public async guardarIndEdit(){
    messages.messageSaving(this.translate.instant('swal.editandoInfo'),this.translate.instant('swal.espere'));
    this.indic.nombre = this.formIndicador.controls['inputNameInd'].value;
    this.indic.descripcion = this.formIndicador.controls['inputDescription'].value;
    if(this.indic.descripcion === ''){
      this.indic.descripcion = ' ';
    }
    this.indic.calculo = this.formIndicador.controls['inputCalculation'].value;
    this.indic.objetiveId = Number(this.formIndicador.controls['inputObjective'].value);
    this.indic.parametro =  this.formIndicador.controls['inputParam'].value;
    if(this.indic.parametro === ''){
      this.indic.parametro = ' ';
    }
    this.indic.linea_base = ''+this.formIndicador.controls['inputBaseLine'].value;
    this.indic.fecha_inicio = new Date((this.formIndicador.controls['inputFechaIn'].value));
    this.indic.fecha_fin = new Date(this.formIndicador.controls['inputFechaFn'].value);
    this.indic.meta_global = this.formIndicador.controls['inputGlobalGoal'].value;
    this.indic.periodicidad = this.formIndicador.controls['inputPeriodicidad'].value;
    this.indic.measureId = this.formIndicador.controls['inputUnidadMed'].value;
    this.indic.tendencia = this.formIndicador.controls['inputTendencia'].value;
    this.indic.areaId = this.formIndicador.controls['inputArea'].value;

    try{
      await firstValueFrom(this.indicadorService.patchIndicadores(this.indic));
      this.indic.fecha_inicio = moment(this.formIndicador.controls['inputFechaIn'].value);
      this.indic.fecha_fin = moment(this.formIndicador.controls['inputFechaFn'].value);
      Swal.close();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));

    }catch(err){
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }   
    this.closeModal();
  }
  // Nuevo indicador
  public async guardarInd(){
    messages.messageSaving(this.translate.instant('swal.agregandoInfo'),this.translate.instant('swal.espere'));
    var indicador = new Indicadores();
    if(this.verCodigo){
      var codigo = this.formIndicador.controls.inputCodigo.value === "" ? ' ': this.formIndicador.controls.inputCodigo.value;
    }else{
      codigo = ' ';
    }
    indicador.nombre = this.formIndicador.controls.inputNameInd.value;
    indicador.descripcion = this.formIndicador.controls.inputDescription.value === "" ? ' ': this.formIndicador.controls.inputDescription.value;
    indicador.calculo = this.formIndicador.controls.inputCalculation.value;
    indicador.objetiveId = Number(this.formIndicador.controls.inputObjective.value);
    indicador.parametro =  this.formIndicador.controls.inputParam.value === "" ? ' ' : this.formIndicador.controls.inputParam.value;
    indicador.linea_base = this.formIndicador.controls.inputBaseLine.value+'';
    indicador.fecha_inicio = new Date(this.formIndicador.controls.inputFechaIn.value);
    indicador.fecha_fin = new Date(this.formIndicador.controls.inputFechaFn.value);
    indicador.meta_global = Number(this.formIndicador.controls.inputGlobalGoal.value);
    indicador.periodicidad = this.formIndicador.controls.inputPeriodicidad.value;
    indicador.measureId = Number(this.formIndicador.controls.inputUnidadMed.value);
    indicador.tendencia = this.formIndicador.controls.inputTendencia.value;
    indicador.areaId = Number(this.formIndicador.controls.inputArea.value);

    try{
      // return;
      const res = await firstValueFrom(this.indicadorService.postIndicadores(indicador));
      const ob = this.objetivos.find(o => Number(o.id) === res.objectiveId);
      const re = this.areas.find(a => Number(a.id) === res.areaId);
      var indN = {
        id: res.id,
        nombre: res.name,
        descripcion: res.description,
        calculo: res.calculation,
        ponderacion: res.weighing,
        objetiveId: res.objectiveId,
        objective: ob,
        linea_base: res.baseline,
        fecha_inicio: moment(res.initialDate.split('T')[0]),
        fecha_fin: moment(res.endDate.split('T')[0]),
        periodicidad: res.periodicity,
        meta_global: res.globalGoal,
        measureId: res.measureId,
        areaId: res.areaId,
        area: {...re, name: re.nombre},
        tendencia: res.tendency,
        parametro: res.paramType,
        adicionales: [],
        perspective: this.perspectiva(res.objectiveId),
        metas: [],
      }

      if(this.indicadoresAll.length !== 0 && this.indicadoresAll[0]?.adicionales.length !== 0){
        for(const ad of this.indicadoresAll[0].adicionales){
          var adic = new Adicionales();
          adic.nombre = ad.name;
          adic.tipo = ad.type;
          adic.indicadorId = indN.id;
          adic.nota = '';
          adic.archivos = '';
          adic.monto = 0;

          try{
            const ad = await firstValueFrom(this.adicionalService.postAdicionales(adic));
            indN.adicionales.push({comments: [], ...ad});
          }catch(err){
            Swal.close();
            let er = obtenerError.errorObt(err['error'].message);
            messages.errorMessageGraph(er);
          }
        }
      }
      indN.adicionales = this.ordenamientoAdi(indN.adicionales);
      this.indicadoresAll.push(indN);
      this.indicadoresAll = this.ordenamientoPer(this.indicadoresAll);
      this.indicadoresAll = this.ordenamientoInd(this.indicadoresAll);
      this.obtDataMostrar();
      messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
    }catch(err){
      Swal.close();
      let er = obtenerError.errorObt(err['error'].message);
      messages.errorMessageGraph(er);
    }
    this.closeModal();
  }

   /** Exportación en excel */
  public exportar_excel(){
    let subtitulosTablas: any = [];
    let contenidoTabla: any = [];
    let headers: any = [];
    
    this.perspectivas.forEach((pers: any, indx) => {
      if(pers.check){
        subtitulosTablas.push(pers.nombre);
        let meses: string[] = [];
        this.meses.forEach((m) => {
          meses.push(m.name);
        });
        let indicadoresAdicionales: string[] = [];
        if (this.indicadores.length != 0) {
          this.indicadores[0].adicionales.forEach((i: any) => {
            indicadoresAdicionales.push(i.name);
          });
        }
        headers.push([
          'Objetivo',
          'Indicador',
          'Ponderación',
          'Área responsable',
          'Línea base',
          'Meta global',
          'Frecuencia',
          ...meses,
          ...indicadoresAdicionales,
        ]);
        let contenido: any = [];
        this.indicadores.forEach((ind, indx) => {
          if(ind.perspective === pers.nombre){
            let mss: any = []
            for(const m of this.meses){
              mss.push( this.escrituraMet(m.name,ind.id, ind))
            }
            let adds: any = []
            for(const a of ind.adicionales){
              adds.push(this.imprimir(a))
            }
            contenido.push(
              [this.escribiObj(this.obtObj(ind),ind,indx), 
                ind.nombre, 
                ind.ponderacion, 
                this.escArea(ind.areaId),
                ind.linea_base,
                ind.meta_global,
                ind.periodicidad,
                ...mss,
                ...adds
              ])
              }
            });
        contenidoTabla.push(contenido);
      }
    });

    const aniosSelecc = [];
    for(const a of this.aniosDisponibles){
      if(a.check){
        aniosSelecc.push(a.name);
      }
    }
    this.excelService.generateExcelIndicadoresFormulacion(
      'Formulación: Indicadores-metas',aniosSelecc, subtitulosTablas, headers, contenidoTabla, "Indicadores_metas"
    );
  }
  public escArea(id: any){
    for(const are of this.areas){
      if(are.id === id)
        return are.nombre;
    }
    return '';
  }
  public obtObj(ind: any){
    for(const obj of this.objetivos){
      if(Number(ind.objetiveId) === Number(obj.id)){
        return obj.nombre;
      }
    }
    return '';
  }

  public ponderacionAutomatica() {
    this.objetivos.forEach(obj => {

      const indicadores = this.indicadoresAll.filter(
        ind => ind.objetiveId === Number(obj.id)
      );

      if (!indicadores.length) return;

      const cantidad = indicadores.length;
      const base = Math.floor((100 / cantidad) * 10) / 10;
      let acumulado = 0;

      indicadores.forEach( async (ind, index) => {
        if (index === cantidad - 1) {
          ind.ponderacion = +(100 - acumulado).toFixed(1);
        } else {
          ind.ponderacion = base;
          acumulado += base;
        }
        await firstValueFrom(this.indicadorService.patchIndicadoresPond(ind));
      });
    });
    messages.succesMessageGraph(this.translate.instant('swal.swalGuardo'));
  }

}
